import { useMutation } from "@tanstack/react-query";
import { useRefreshAlgoliaData } from "entities/algolia/hooks/useRefreshAlgoliaData";
import { createThemeTag } from "../api/createThemeTag";
import { CreateThemeTag } from "../types";
import { invalidateThemeTagDetailsQuery } from "./useThemeTagDetailsQuery";

type Params = {
  themeTag: CreateThemeTag;
};

const INITIAL_DELAY_MS = 2000;
const REFRESH_INTERVAL_MS = 5000;

export const useCreateThemeTagMutation = () => {
  const { refreshAlgoliaData } = useRefreshAlgoliaData();

  return useMutation({
    mutationFn: async ({ themeTag }: Params) => {
      const response = await createThemeTag(themeTag);
      invalidateThemeTagDetailsQuery(String(response.id));
    },
    onSuccess: (_) => {
      // Invalidate query and refetch Algolia
      refreshAlgoliaData(INITIAL_DELAY_MS);
      refreshAlgoliaData(REFRESH_INTERVAL_MS);
    },
    onError: (e) => console.error(e),
  });
};
